import { findRegions } from '~/Api/Analytics/Region';
import { invokeApi, tryResolve } from '~/ApiClient';
import { handleError } from '~/ErrorHandler';
import { ThunkAction } from '~/Store';

import ActionTypes from './ActionTypes';

export function fetchRegions(): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const request = dispatch(invokeApi(findRegions));
		dispatch({ type: ActionTypes.request, request });

		await tryResolve(request, (response, error) => {
			dispatch({
				type: ActionTypes.receive,
				request,
				regions: response?.items,
			});
			if (error) {
				dispatch(handleError(error));
			}
		});
	};
}
